$(function(){
    // ページ上部 バナー
    if (window.matchMedia('(max-width: 879px)').matches) {
        var minimum = 2;
    }
    else if (window.matchMedia('(max-width: 1099px)').matches) {
        var minimum = 4;
    }
    else {
        var minimum = 5;
    }
     setTimeout(() => {
        var slideLength = $('.banners-inn li').length;
    
        if ( slideLength >= minimum ) {
            $('.banners-inn').slick({
                arrows: true,
                prevArrow:'<div class=slick-arrow-prev></div>',
                nextArrow:'<div class=slick-arrow-next></div>',
                pauseOnFocus: false,
                pauseOnHover: false,
                slidesToShow: 4,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 880,
                        settings: {
                            arrows: false,
                            slidesToShow: 1.5,
                        } 
                    },
                ]
            });
            $('.banners-inn').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                if (nextSlide > 0) {
                    $('.slick-arrow-prev').css('visibility', 'visible');
                } else {
                    $('.slick-arrow-prev').css('visibility', 'hidden');
                }
            });
        } else {
            $('.banners-inn').addClass('no-slide');
        }      
    }, 1000);

    // シリーズ一覧 開閉
    var seriesToggleButton = $('.js-series-title');
    var seriesToggleCont = $('.js-series-toggle-cont');
    var seriesClose = $('.js-series-close');
    
    seriesClose.on('click', function() {
    
      var currentPosition = $(window).scrollTop();
      var closeTarget = $(this).parents('.js-series-toggle-cont');
      var closeTargetHeight = $(this).parents('.js-series-toggle-cont').height();
      
      if (closeTarget.hasClass('is-open') == true) {
        closeTarget.slideUp().removeClass('is-open');
        closeTarget.prev(seriesToggleButton).find('.series-title-arrow').removeClass('is-open');
        $('body, html').animate({ scrollTop: currentPosition - closeTargetHeight }, 400);
      }
    });
    seriesToggleButton.on('click', function() {
      var openTarget = $(this).next(seriesToggleCont);
      if (openTarget.hasClass('is-open') == false) {
        openTarget.slideDown().addClass('is-open');
        $(this).find('.series-title-arrow').addClass('is-open');
      } else {
        openTarget.slideUp().removeClass('is-open');
        $(this).find('.series-title-arrow').removeClass('is-open');
      }
    });

    //var text = '<div class="knot-magazine"><p class="knot-magazine-title">Knot <span>Magazine</span></p><ul class="knot-magazine-list"><li class="knot-magazine-item knot-magazine-1"><a href="" target="_blank" rel="noopener noreferrer"><p class="title">タイトルタイトルタイトル</p><p class="date">2022.01.01</p></a></li><li class="knot-magazine-item knot-magazine-2"><a href="" target="_blank" rel="noopener noreferrer"><p class="title"></p><p class="date"></p></a></li><li class="knot-magazine-item knot-magazine-3"><a href="" target="_blank" rel="noopener noreferrer"><p class="title"></p><p class="date"></p></a></li><li class="knot-magazine-item knot-magazine-4"><a href="" target="_blank" rel="noopener noreferrer"><p class="title"></p><p class="date"></p></a></li><li class="knot-magazine-item knot-magazine-5"><a href="" target="_blank" rel="noopener noreferrer"><p class="title">タイトルタイトルタイトル</p><p class="date">2022.01.01</p></a></li><li class="knot-magazine-item knot-magazine-6"><a href="" target="_blank" rel="noopener noreferrer"><p class="title"></p><p class="date"></p></a></li><li class="knot-magazine-item knot-magazine-7"><a href="" target="_blank" rel="noopener noreferrer"><p class="title"></p><p class="date"></p></a></li><li class="knot-magazine-item knot-magazine-8"><a href="" target="_blank" rel="noopener noreferrer"><p class="title"></p><p class="date"></p></a></li><li class="knot-magazine-item knot-magazine-9"><a href="" target="_blank" rel="noopener noreferrer"><p class="title"></p><p class="date"></p></a></li><li class="knot-magazine-item knot-magazine-10"><a href="" target="_blank" rel="noopener noreferrer"><p class="title"></p><p class="date"></p></a></li></ul></div>'
    //console.log(text);
    //$('.facets-container').after(text);

    var ww = $(window).width();
    if(ww < 880) {
      var mobileSort = $('div.mobile-facets__details.js-filter').html();
      $('div.mobile-facets__details.js-filter').hide();
      $('h2.product-count__text.text-body').after(mobileSort);

    }

    // 絞り込み 上段3つ開く
    $('details[data-index=2], details[data-index=3]').attr('open', '');

    // Knot Magazine
    var magazine = $('.knot-magazine');
    $('.facets-container').after(magazine);

    // 絞り込み
    var target = $('#sortTop').scrollTop();
    console.log(target);
    $('.facets-vertical').on('click', '.list-menu__item', function(){
        // console.log('click');
        const $header = $('header'); // ヘッダー要素
        const headerHeight = $header.outerHeight() || 0; // 高さを取得（パディング含む）
        $('html, body').animate({scrollTop:$('#sortTop').offset().top - headerHeight});
    });
  
});

//$(window).on('load', function(){
//    var ww = $(window).width();
//    if(ww < 880) {
//      setTimeout(function(){      
//        var target = $('#ProductGridContainer').offset().top;
//        var wh = $(window).height();
//        $(document).on('click', '.mobile-facets__footer .button', function(){
//          $(window).scrollTop(target - 120);
//        });
//      }, 2000);
//    }
//});
